import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { GraphemePanelsMnemonicsTabContextValue } from "#grapheme-panels-mnemonics-tab-context-value";

export const GraphemePanelsMnemonicsTabContext = createContext(
  defaultError<GraphemePanelsMnemonicsTabContextValue>("GraphemePanelsMnemonicsTabContext"),
);
